import { render, staticRenderFns } from "./BasicDetailsEditModal.vue?vue&type=template&id=2650df49&scoped=true&"
import script from "./BasicDetailsEditModal.vue?vue&type=script&lang=js&"
export * from "./BasicDetailsEditModal.vue?vue&type=script&lang=js&"
import style0 from "./BasicDetailsEditModal.vue?vue&type=style&index=0&id=2650df49&prod&scoped=true&lang=css&"
import style1 from "./BasicDetailsEditModal.vue?vue&type=style&index=1&id=2650df49&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2650df49",
  null
  
)

export default component.exports